export const paymentConfirmationTranslations = {
    en: {
        confirmation: {
            received: 'Payment Received',
            thankyou: 'Thank you for your payment.',
        }
    },
    nl: {
        confirmation: {
            received: 'Betaling Ontvangen',
            thankyou: 'Bedankt voor je betaling.',
        }
    }
}; 